import { useCallback } from 'react';
import { css, useTheme } from 'styled-components';

import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const IconBullet = (props) => (
  <svg {...props} viewBox="0 0 510.172 510.172">
    <path
      fill="currentColor"
      d="M491.886 62.171H190.171c-10.971 0-18.286 7.314-18.286 18.286s9.143 18.286 18.286 18.286h301.715c10.971 0 18.286-7.314 18.286-18.286s-7.314-18.286-18.286-18.286zM493.714 237.714H190.171c-10.971 0-18.286 7.314-18.286 18.286s7.314 18.286 18.286 18.286h301.715c10.971 0 18.286-7.314 18.286-18.286s-7.314-18.286-16.458-18.286zM493.714 413.257H190.171c-10.971 0-18.286 7.314-18.286 18.286 0 10.971 7.314 18.286 18.286 18.286h301.715c10.971 0 18.286-7.314 18.286-18.286 0-10.972-7.314-18.286-16.458-18.286zM65.829 14.629C29.257 14.629 0 43.886 0 80.457s29.257 65.829 65.829 65.829c36.571 0 65.829-29.257 65.829-65.829-.001-36.571-29.258-65.828-65.829-65.828zm0 96.914c-16.458 0-29.257-12.799-29.257-29.257 0-16.458 12.8-29.257 29.257-29.257 16.458 0 29.257 12.8 29.257 29.257 0 14.629-12.8 29.257-29.257 29.257zM65.829 190.171C29.257 190.171 0 219.429 0 256s29.257 65.829 65.829 65.829c36.571 0 65.829-29.257 65.829-65.829s-29.258-65.829-65.829-65.829zm0 95.086c-16.458 0-29.257-12.8-29.257-29.257s12.8-29.257 29.257-29.257c16.458 0 29.257 12.799 29.257 29.257s-12.8 29.257-29.257 29.257zM65.829 363.886C29.257 363.886 0 393.143 0 429.715s29.257 65.829 65.829 65.829c36.571 0 65.829-29.257 65.829-65.829-.001-34.744-29.258-65.829-65.829-65.829zm0 96.914c-16.458 0-29.257-12.8-29.257-29.257s12.8-29.257 29.257-29.257c16.458 0 29.257 12.8 29.257 29.257S82.286 460.8 65.829 460.8z"
    />
  </svg>
);
const IconOrdered = (props) => (
  <svg {...props} viewBox="0 0 512.003 512.003">
    <path
      fill="currentColor"
      d="M155.003 90.001h342c8.284 0 15-6.716 15-15s-6.716-15-15-15h-342c-8.284 0-15 6.716-15 15s6.716 15 15 15zM497.003 241.001h-342c-8.284 0-15 6.716-15 15s6.716 15 15 15h342c8.284 0 15-6.716 15-15s-6.716-15-15-15zM497.003 422.001h-342c-8.284 0-15 6.716-15 15s6.716 15 15 15h342c8.284 0 15-6.716 15-15s-6.716-15-15-15zM26.003 30.001h8.512v95c0 8.284 6.716 15 15 15s15-6.716 15-15v-110c0-8.284-6.716-15-15-15H26.003c-8.284 0-15 6.716-15 15s6.716 15 15 15zM74.083 295.753c-8.847.111-18.162.192-26.478.228 5.659-7.649 13.006-17.786 22.378-31.176 7.1-10.143 11.74-19.777 13.794-28.635.114-.491.203-.987.267-1.487l.533-4.173c.081-.63.121-1.265.121-1.901 0-23.494-19.113-42.607-42.606-42.607-20.314 0-37.897 14.453-41.808 34.365-1.597 8.129 3.699 16.013 11.828 17.609 8.13 1.595 16.013-3.699 17.609-11.828 1.154-5.879 6.357-10.146 12.37-10.146 6.692 0 12.183 5.242 12.583 11.835l-.281 2.203c-.932 3.577-3.26 9.377-8.988 17.563-17.055 24.369-27.23 37.691-32.696 44.849-6.906 9.042-10.71 14.023-8.206 22.166 1.492 4.849 5.153 8.565 10.048 10.196 2.03.677 3.657 1.219 24.6 1.219 8.314 0 19.673-.085 35.31-.282 8.283-.104 14.914-6.904 14.811-15.188-.106-8.283-6.918-14.902-15.189-14.81zM44.637 372.001c-20.264 0-37.802 14.417-41.702 34.28-1.597 8.129 3.699 16.013 11.828 17.609 8.13 1.595 16.013-3.699 17.609-11.829 1.145-5.829 6.303-10.06 12.265-10.06 6.893 0 12.5 5.607 12.5 12.5s-5.607 12.5-12.5 12.5c-8.284 0-15 6.716-15 15s6.716 15 15 15c6.893 0 12.5 5.607 12.5 12.5s-5.607 12.5-12.5 12.5c-6.202 0-11.524-4.616-12.378-10.736a12.793 12.793 0 01-.122-1.764c0-8.284-6.716-15-15-15s-15 6.716-15 15c0 1.972.138 3.959.409 5.909 2.911 20.86 21.007 36.591 42.091 36.591 23.435 0 42.5-19.065 42.5-42.5 0-10.481-3.822-20.082-10.134-27.5 6.313-7.418 10.134-17.019 10.134-27.5 0-23.434-19.066-42.5-42.5-42.5z"
    />
  </svg>
);

const List = ({ onItemClick, value, css: baseCss, ...otherProps }) => {
  const { quillRef } = useQuillEditorContext();

  const handleToggleValue = useCallback(
    (type) => () => {
      quillRef.current.format('list', value === type ? false : type, 'user');
      onItemClick();
    },
    [value],
  );

  const theme = useTheme();

  const commonCss = `
  color: ${theme.colors.white} !important;
  margin-left: 0;
  padding: ${theme.space[1]}px;
  height: 24px;
  width: 24px;

  &:hover {
    background-color: ${theme.colors.builder.toolbar.itemHover};
  }
`;

  return (
    <>
      <Tooltip
        initialPosition={POSITIONS.BOTTOM}
        childrenElement={__('Bulleted list')}
      >
        <ToolbarItem
          icon={IconBullet}
          isActive
          onClick={handleToggleValue('bullet')}
          {...otherProps}
          // TODO: Remove when new Builder Toolbar
          css={css`
            ${commonCss}
            background-color: ${value === 'bullet'
              ? theme.colors.builder.toolbar.itemHover
              : undefined};
          `}
        />
      </Tooltip>
      <Tooltip
        initialPosition={POSITIONS.BOTTOM}
        childrenElement={__('Numbered list')}
      >
        <ToolbarItem
          onClick={handleToggleValue('ordered')}
          isActive
          icon={IconOrdered}
          {...otherProps}
          // TODO: Remove when new Builder Toolbar
          css={css`
            ${commonCss}
            background-color: ${value === 'ordered'
              ? theme.colors.builder.toolbar.itemHover
              : undefined};
          `}
        />
      </Tooltip>
    </>
  );
};

List.getFormat = (format) => format?.list;

export default List;
